module.exports = __webpack_public_path__ + "static/GBR-ef326eaf8bc1e2d1f1c3907e6cb4ecd3.png";